import { SubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/SubmissionModuleState.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import styled from 'styled-components';
import { ModuleStateProgressBarItem } from './ModuleStateProgressBarItem.tsx';

const ProgressWrapper = styled.div`
  border-radius: ${props => props.theme.borderRadius - 1}px;
  background-color: #fff;
  padding: 1px;
`;

export interface IModuleStateProgressBarProps {
  /** stato corretnte del modulo */
  currentState: SubmissionModuleState;
  /** Indica che il modulo deve essere firmato */
  hasSignatures?: boolean;
  /** Indica se lo stato del form è corretto o no */
  isValid: boolean | null | undefined;
}

/**
 * Progress bar per lo stato di un modulo
 *
 */
export function ModuleStateProgressBar(props: IModuleStateProgressBarProps) {
  const { currentState, hasSignatures, isValid } = props;

  // PS: Non inserire elementi tra i componenti  <ModuleStateProgressBarItem />
  // per evitare errori di rendering (utilizzati per il css)
  return (
    <ProgressWrapper
      role="list"
      aria-label={t(
        'module.state-progress-bar.stato-del-modulo',
        'Stato del Modulo',
      )}
    >
      <ModuleStateProgressBarItem
        current={currentState}
        state={SubmissionModuleState.Compilation}
        isValid={isValid}
      />
      {hasSignatures && (
        <ModuleStateProgressBarItem
          current={currentState}
          state={SubmissionModuleState.Sign}
        />
      )}
      <ModuleStateProgressBarItem
        current={currentState}
        state={SubmissionModuleState.Completed}
      />
    </ProgressWrapper>
  );
}
